import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";

export default () => {
    const title = 'Памятный знак. 1999-2006 г.г.';

    const images = [
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/01.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/01.jpg'),
            description: 'Это место до 1999 г.'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/02.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/02.jpg'),
            description: 'Мемориальный камень до 1999 г.'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/03.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/03.jpg'),
            description: 'Поставлен в 1999 г.'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/04.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/04.jpg'),
            description: '30 ноября 2003 г.'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/05.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/05.jpg'),
            description: '4 февраля 2004 года'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/06.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/06.jpg'),
            description: '4 февраля 2004 года'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/07.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/07.jpg'),
            description: '2006 год.'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/08.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/08.jpg'),
            description: '2006 год.'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoMemorialSign/09.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoMemorialSign/09.jpg'),
            description: '4 февраля 2006 года'
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <div className="onehalf-col-cell">
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}